/*
 * SC Lightbox — pełnoekranowe oglądanie zdjęć produktu.
 *
 * Napisany od zera zamiast wciągania PhotoSwipe z obcego CDN: motyw ma już
 * skrypty blokujące render (jQuery 95 KB), a doklejenie kolejnej biblioteki
 * z zewnętrznego hosta dokłada DNS, transfer i zależność, nad którą nie mamy
 * kontroli. Tutaj jest tylko to, czego ten sklep faktycznie potrzebuje.
 *
 * Zdjęcia są w tym sklepie dowodem stanu egzemplarza (odzież używana), więc
 * priorytetem jest obejrzenie detalu na telefonie: powiększenie, przesuwanie
 * powiększonego kadru i szybkie przejście między zdjęciami.
 *
 * ANIMACJA OTWARCIA I ZAMKNIĘCIA (technika FLIP)
 * Kafel startuje dokładnie w miejscu i rozmiarze klikniętego zdjęcia na
 * stronie, po czym przechodzi do pozycji pełnoekranowej. Przy zamknięciu
 * wraca tam, skąd wyszedł. Dzięki temu klient nie gubi kontekstu.
 *
 * GESTY
 *   przesunięcie w bok        następne albo poprzednie zdjęcie
 *   przesunięcie w dół        zamknięcie, z tłem gasnącym proporcjonalnie
 *   dwukrotne stuknięcie      przybliżenie w punkt stuknięcia i z powrotem
 *   szczypnięcie dwoma palcami   płynne przybliżanie
 *   przeciąganie po zbliżeniu    przesuwanie kadru
 *
 * Klawiatura: strzałki przechodzą między zdjęciami, Escape zamyka.
 */
(function () {
  'use strict';

  var ZOOM_MAX = 4;
  var ZOOM_DBL = 2.5;          // przybliżenie po dwukrotnym stuknięciu
  var PROG_ZAMKNIECIA = 110;   // px przesunięcia w dół, po których zamykamy
  var PROG_ZMIANY = 60;        // px przesunięcia w bok, po których zmieniamy zdjęcie
  var CZAS = 260;              // ms, wspólny czas animacji

  var redukcjaRuchu = window.matchMedia('(prefers-reduced-motion: reduce)');

  function czas() { return redukcjaRuchu.matches ? 0 : CZAS; }
  function ogranicz(v, min, max) { return v < min ? min : (v > max ? max : v); }

  /*
   * Odpala `cb` w kolejnej klatce, żeby przeglądarka zdążyła namalować stan
   * startowy animacji (bez tego oba stany trafiają do jednej klatki i przejście
   * nie jest widoczne).
   *
   * 🚨 `requestAnimationFrame` MILCZY w karcie w tle i w ukrytym oknie. Bez
   * bezpiecznika lightbox zostawał wtedy w pozycji startowej: zdjęcie
   * mikroskopijne, tło przezroczyste. Zmierzone na żywo. Dlatego obok rAF
   * stoi setTimeout, a `cb` wykonuje się dokładnie raz.
   */
  function poNastepnejKlatce(cb) {
    var wykonano = false;
    function raz() { if (!wykonano) { wykonano = true; cb(); } }
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(function () { requestAnimationFrame(raz); });
    }
    setTimeout(raz, 60);
  }

  function Lightbox(zrodla, opisy) {
    this.zrodla = zrodla;
    this.opisy = opisy || [];
    this.i = 0;
    this.skala = 1;
    this.przesX = 0;
    this.przesY = 0;
    this.zbuduj();
  }

  Lightbox.prototype.zbuduj = function () {
    var self = this;
    var el = document.createElement('div');
    el.className = 'scl';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Zdjęcia produktu');
    el.innerHTML =
      '<div class="scl__bg"></div>' +
      '<div class="scl__stage"><div class="scl__slide"><img class="scl__img" alt=""></div></div>' +
      '<div class="scl__ui">' +
        '<button type="button" class="scl__close" aria-label="Zamknij">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<button type="button" class="scl__nav scl__nav--prev" aria-label="Poprzednie zdjęcie">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg></button>' +
        '<button type="button" class="scl__nav scl__nav--next" aria-label="Następne zdjęcie">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg></button>' +
        '<p class="scl__count" aria-live="polite"></p>' +
        '<p class="scl__hint"></p>' +
      '</div>';
    document.body.appendChild(el);

    this.el = el;
    this.tlo = el.querySelector('.scl__bg');
    this.slide = el.querySelector('.scl__slide');
    this.img = el.querySelector('.scl__img');
    this.licznik = el.querySelector('.scl__count');
    this.wskazowka = el.querySelector('.scl__hint');
    this.btnPrev = el.querySelector('.scl__nav--prev');
    this.btnNext = el.querySelector('.scl__nav--next');

    el.querySelector('.scl__close').addEventListener('click', function () { self.zamknij(); });
    this.btnPrev.addEventListener('click', function () { self.idz(-1); });
    this.btnNext.addEventListener('click', function () { self.idz(1); });
    this.tlo.addEventListener('click', function () { self.zamknij(); });

    this.podepnijGesty();
  };

  Lightbox.prototype.otworz = function (index, elZrodlowy) {
    var self = this;
    this.i = index;
    this.elZrodlowy = elZrodlowy || null;
    this.scrollY = window.scrollY || window.pageYOffset;

    this.el.setAttribute('data-open', '');
    document.body.classList.add('scl-open');
    document.body.style.top = (-this.scrollY) + 'px';

    this.pokazZdjecie(index, function () {
      // FLIP: liczymy pozycję startową dopiero, gdy znamy realny rozmiar kadru.
      self.animujWejscie();
    });

    this.poprzedniFokus = document.activeElement;
    this.el.querySelector('.scl__close').focus({ preventScroll: true });
  };

  Lightbox.prototype.pokazZdjecie = function (index, gotowe) {
    var self = this;
    this.i = ogranicz(index, 0, this.zrodla.length - 1);
    this.resetTransformu();

    var src = this.zrodla[this.i];
    this.img.alt = this.opisy[this.i] || '';

    // 🚨 `src` ustawiamy NATYCHMIAST, a nie po doładowaniu w buforze.
    // Wcześniej licznik przeskakiwał od razu, a zdjęcie zostawało poprzednie,
    // więc przy szybkim przeklikiwaniu numer nie zgadzał się z obrazem
    // (zmierzone: po kliknięciu „następne" licznik pokazywał 2/5 przy zdjęciu
    // pierwszym). Przeglądarka i tak rysuje obraz progresywnie.
    this.img.src = src;

    if (gotowe) {
      // Animacja wejścia potrzebuje realnych wymiarów kadru, więc czeka na load.
      if (this.img.complete && this.img.naturalWidth) {
        gotowe();
      } else {
        this.img.addEventListener('load', function raz() {
          self.img.removeEventListener('load', raz);
          gotowe();
        });
        // Gdyby zdjęcie się nie wczytało, lightbox i tak ma się otworzyć.
        setTimeout(function () { if (!self.el.hasAttribute('data-ready')) gotowe(); }, 1200);
      }
    }

    // Wstępne pobranie sąsiednich zdjęć, żeby przewijanie było płynne.
    [this.i + 1, this.i - 1].forEach(function (j) {
      if (j >= 0 && j < self.zrodla.length) { var p = new Image(); p.src = self.zrodla[j]; }
    });

    this.licznik.textContent = (this.i + 1) + ' / ' + this.zrodla.length;
    this.btnPrev.disabled = this.i === 0;
    this.btnNext.disabled = this.i === this.zrodla.length - 1;
    this.wskazowka.textContent = this.zrodla.length > 1
      ? 'Przesuń, aby zobaczyć kolejne. Stuknij dwa razy, aby przybliżyć.'
      : 'Stuknij dwa razy, aby przybliżyć.';
  };

  Lightbox.prototype.animujWejscie = function () {
    var self = this;
    var t = czas();
    if (!t || !this.elZrodlowy) {
      this.tlo.style.transition = 'opacity ' + t + 'ms ease';
      this.tlo.style.opacity = '1';
      this.el.setAttribute('data-ready', '');
      return;
    }

    var od = this.elZrodlowy.getBoundingClientRect();
    var doK = this.img.getBoundingClientRect();
    if (!doK.width || !doK.height) {
      this.tlo.style.opacity = '1';
      this.el.setAttribute('data-ready', '');
      return;
    }

    var sx = od.width / doK.width;
    var sy = od.height / doK.height;
    var dx = (od.left + od.width / 2) - (doK.left + doK.width / 2);
    var dy = (od.top + od.height / 2) - (doK.top + doK.height / 2);

    this.img.style.transition = 'none';
    this.img.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
    this.tlo.style.transition = 'none';
    this.tlo.style.opacity = '0';

    // 🚨 Samo `void offsetWidth` tu NIE WYSTARCZA: przeglądarka i tak scala
    // oba zapisy stylu w jedną klatkę i animacja nie rusza (zmierzone: kadr
    // zostawał w pozycji startowej). Dopiero drugie `requestAnimationFrame`
    // gwarantuje, że stan startowy zdążył zostać namalowany.
    poNastepnejKlatce(function () {
      self.img.style.transition = 'transform ' + t + 'ms cubic-bezier(.2,.7,.3,1)';
      self.img.style.transform = 'translate(0,0) scale(1)';
      self.tlo.style.transition = 'opacity ' + t + 'ms ease';
      self.tlo.style.opacity = '1';
      setTimeout(function () {
        self.img.style.transition = '';
        self.el.setAttribute('data-ready', '');
      }, t);
    });
  };

  Lightbox.prototype.zamknij = function () {
    var self = this;
    var t = czas();
    this.el.removeAttribute('data-ready');

    var wroc = function () {
      self.el.removeAttribute('data-open');
      self.img.style.transition = '';
      self.img.style.transform = '';
      self.tlo.style.transition = '';
      self.tlo.style.opacity = '0';
      document.body.classList.remove('scl-open');
      document.body.style.top = '';
      window.scrollTo(0, self.scrollY || 0);
      if (self.poprzedniFokus && self.poprzedniFokus.focus) {
        self.poprzedniFokus.focus({ preventScroll: true });
      }
    };

    if (!t || !this.elZrodlowy) { wroc(); return; }

    var od = this.elZrodlowy.getBoundingClientRect();
    var doK = this.img.getBoundingClientRect();
    if (!doK.width || !od.width) { wroc(); return; }

    // Kadr wraca tam, skąd wyszedł. Uwzględniamy bieżące przesunięcie,
    // żeby zamknięcie gestem nie „przeskakiwało" przed animacją.
    var sx = od.width / (doK.width / this.skala);
    var sy = od.height / (doK.height / this.skala);
    var dx = (od.left + od.width / 2) - (doK.left + doK.width / 2) + this.przesX;
    var dy = (od.top + od.height / 2) - (doK.top + doK.height / 2) + this.przesY;

    this.img.style.transition = 'transform ' + t + 'ms cubic-bezier(.4,0,.6,1)';
    this.img.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')';
    this.tlo.style.transition = 'opacity ' + t + 'ms ease';
    this.tlo.style.opacity = '0';
    setTimeout(wroc, t);
  };

  Lightbox.prototype.idz = function (kier) {
    var nowy = this.i + kier;
    if (nowy < 0 || nowy >= this.zrodla.length) return;
    var self = this;
    var t = czas();
    // Krótkie przesunięcie w bok jako sygnał kierunku, potem podmiana zdjęcia.
    this.img.style.transition = t ? 'transform ' + (t / 2) + 'ms ease, opacity ' + (t / 2) + 'ms ease' : '';
    this.img.style.transform = 'translateX(' + (-kier * 40) + 'px)';
    this.img.style.opacity = '0';
    setTimeout(function () {
      self.pokazZdjecie(nowy);
      self.img.style.transition = 'none';
      self.img.style.transform = 'translateX(' + (kier * 40) + 'px)';
      self.img.style.opacity = '0';
      // Ten sam powód co przy animacji wejścia: potrzebna jest osobna klatka,
      // inaczej przeglądarka scala oba stany i przejście nie jest widoczne.
      poNastepnejKlatce(function () {
        self.img.style.transition = t
          ? 'transform ' + (t / 2) + 'ms ease, opacity ' + (t / 2) + 'ms ease' : '';
        self.img.style.transform = 'translateX(0)';
        self.img.style.opacity = '1';
      });
    }, t / 2);
  };

  Lightbox.prototype.resetTransformu = function () {
    this.skala = 1;
    this.przesX = 0;
    this.przesY = 0;
    this.img.style.transform = '';
    this.img.style.opacity = '1';
  };

  Lightbox.prototype.zastosuj = function (bezAnimacji) {
    this.img.style.transition = bezAnimacji ? 'none' : 'transform ' + czas() + 'ms cubic-bezier(.2,.7,.3,1)';
    this.img.style.transform =
      'translate(' + this.przesX + 'px,' + this.przesY + 'px) scale(' + this.skala + ')';
  };

  Lightbox.prototype.podepnijGesty = function () {
    var self = this;
    var start = null, ostatnieStuk = 0, tryb = null, startDyst = 0, startSkala = 1;

    function punkty(e) { return Array.prototype.slice.call(e.touches || []); }
    function dystans(a, b) {
      var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    this.el.addEventListener('touchstart', function (e) {
      var p = punkty(e);
      if (p.length === 2) {
        tryb = 'zoom';
        startDyst = dystans(p[0], p[1]);
        startSkala = self.skala;
        return;
      }
      if (p.length !== 1) return;
      start = { x: p[0].clientX, y: p[0].clientY, px: self.przesX, py: self.przesY, t: Date.now() };
      tryb = self.skala > 1 ? 'przesuwanie' : null;
    }, { passive: true });

    this.el.addEventListener('touchmove', function (e) {
      var p = punkty(e);

      if (tryb === 'zoom' && p.length === 2) {
        e.preventDefault();
        self.skala = ogranicz(startSkala * (dystans(p[0], p[1]) / startDyst), 1, ZOOM_MAX);
        self.zastosuj(true);
        return;
      }
      if (!start || p.length !== 1) return;

      var dx = p[0].clientX - start.x;
      var dy = p[0].clientY - start.y;

      if (self.skala > 1) {
        e.preventDefault();
        self.przesX = start.px + dx;
        self.przesY = start.py + dy;
        self.zastosuj(true);
        return;
      }

      if (!tryb) tryb = Math.abs(dx) > Math.abs(dy) ? 'bok' : 'dol';

      if (tryb === 'dol' && dy > 0) {
        e.preventDefault();
        // Tło gaśnie proporcjonalnie do przesunięcia: klient widzi, że gest zamyka.
        self.przesY = dy;
        self.img.style.transition = 'none';
        self.img.style.transform = 'translateY(' + dy + 'px) scale(' + Math.max(0.86, 1 - dy / 1000) + ')';
        self.tlo.style.transition = 'none';
        self.tlo.style.opacity = String(Math.max(0.25, 1 - dy / 420));
      } else if (tryb === 'bok') {
        e.preventDefault();
        self.przesX = dx;
        self.img.style.transition = 'none';
        self.img.style.transform = 'translateX(' + dx + 'px)';
      }
    }, { passive: false });

    this.el.addEventListener('touchend', function (e) {
      if (tryb === 'zoom') {
        tryb = null;
        if (self.skala <= 1.02) { self.resetTransformu(); self.zastosuj(); }
        return;
      }
      if (!start) return;

      var dy = self.przesY, dx = self.przesX;

      if (self.skala > 1) { tryb = null; start = null; return; }

      if (tryb === 'dol' && dy > PROG_ZAMKNIECIA) {
        self.zamknij();
      } else if (tryb === 'bok' && Math.abs(dx) > PROG_ZMIANY) {
        var kier = dx < 0 ? 1 : -1;
        var docelowy = self.i + kier;
        if (docelowy >= 0 && docelowy < self.zrodla.length) {
          self.idz(kier);
        } else {
          self.resetTransformu(); self.zastosuj();
        }
      } else {
        // Gest nie osiągnął progu: wszystko wraca na miejsce.
        self.resetTransformu();
        self.zastosuj();
        self.tlo.style.transition = 'opacity ' + czas() + 'ms ease';
        self.tlo.style.opacity = '1';
      }

      // Dwukrotne stuknięcie: przybliżenie w punkt stuknięcia.
      var teraz = Date.now();
      var krotkie = teraz - start.t < 250 && Math.abs(dx) < 12 && Math.abs(dy) < 12;
      if (krotkie && teraz - ostatnieStuk < 320) {
        if (self.skala > 1) {
          self.resetTransformu();
        } else {
          var r = self.img.getBoundingClientRect();
          var kx = (e.changedTouches[0].clientX - (r.left + r.width / 2));
          var ky = (e.changedTouches[0].clientY - (r.top + r.height / 2));
          self.skala = ZOOM_DBL;
          self.przesX = -kx * (ZOOM_DBL - 1) / ZOOM_DBL;
          self.przesY = -ky * (ZOOM_DBL - 1) / ZOOM_DBL;
        }
        self.zastosuj();
        ostatnieStuk = 0;
      } else if (krotkie) {
        ostatnieStuk = teraz;
      }

      tryb = null;
      start = null;
    }, { passive: true });

    // Desktop: dwuklik przybliża, klawiatura nawiguje.
    this.img.addEventListener('dblclick', function (e) {
      if (self.skala > 1) { self.resetTransformu(); self.zastosuj(); return; }
      var r = self.img.getBoundingClientRect();
      var kx = e.clientX - (r.left + r.width / 2);
      var ky = e.clientY - (r.top + r.height / 2);
      self.skala = ZOOM_DBL;
      self.przesX = -kx * (ZOOM_DBL - 1) / ZOOM_DBL;
      self.przesY = -ky * (ZOOM_DBL - 1) / ZOOM_DBL;
      self.zastosuj();
    });

    document.addEventListener('keydown', function (e) {
      if (!self.el.hasAttribute('data-open')) return;
      if (e.key === 'Escape') { self.zamknij(); }
      else if (e.key === 'ArrowLeft') { self.idz(-1); }
      else if (e.key === 'ArrowRight') { self.idz(1); }
    });
  };

  // ── Podpięcie do galerii na stronie produktu ──────────────────────────────
  function start() {
    var galerie = document.querySelectorAll('[data-scl-gallery]');
    if (!galerie.length) return;

    galerie.forEach(function (gal) {
      var dane;
      try {
        dane = JSON.parse(gal.getAttribute('data-scl-gallery'));
      } catch (err) {
        return; // zła treść atrybutu nie może wywalić strony produktu
      }
      if (!dane || !dane.length) return;

      var zrodla = dane.map(function (d) { return d.src; });
      var opisy = dane.map(function (d) { return d.alt || ''; });
      var lb = null;

      function otworz(index, elZrodlowy) {
        if (!lb) lb = new Lightbox(zrodla, opisy);
        lb.otworz(index, elZrodlowy);
      }

      var glowne = gal.querySelector('[data-scl-main]');
      if (glowne) {
        glowne.addEventListener('click', function () {
          var akt = parseInt(gal.getAttribute('data-scl-index') || '0', 10) || 0;
          otworz(akt, glowne);
        });
        glowne.setAttribute('role', 'button');
        glowne.setAttribute('tabindex', '0');
        glowne.setAttribute('aria-label', 'Powiększ zdjęcie');
        glowne.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            otworz(parseInt(gal.getAttribute('data-scl-index') || '0', 10) || 0, glowne);
          }
        });
      }

      // Miniatura podmienia zdjęcie główne i zapamiętuje, które jest aktywne,
      // żeby lightbox otworzył się na właściwym.
      gal.querySelectorAll('[data-scl-thumb]').forEach(function (btn, idx) {
        btn.addEventListener('click', function () {
          gal.setAttribute('data-scl-index', String(idx));
          if (glowne) {
            var im = glowne.tagName === 'IMG' ? glowne : glowne.querySelector('img');
            if (im) im.src = zrodla[idx];
          }
          gal.querySelectorAll('[data-scl-thumb]').forEach(function (b, j) {
            b.setAttribute('aria-current', j === idx ? 'true' : 'false');
          });
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
